export enum Domains {
  HOTEL = 'otel',
  TOUR = 'tur',
  FLIGHT_DOMESTIC = 'ic-hat-ucuslari',
  FLIGHT_ABROAD = 'dis-hat-ucuslari',
  CAR = 'arac-kiralama',
}

type SearchBarDomain = {
  isDomainFlight: boolean;
  isDomainTour: boolean;
  isDomainHotel: boolean;
  isDomainCar: boolean;
};

const initialData = {
  isDomainFlight: false,
  isDomainHotel: false,
  isDomainTour: false,
  isDomainCar: false,
};

export const getDomain = (pathname): SearchBarDomain => {
  const domain = pathname.split('/')?.[1];
  switch (domain) {
    case Domains.HOTEL:
      return {
        ...initialData,
        isDomainHotel: true,
      };
    case Domains.TOUR:
      return {
        ...initialData,
        isDomainTour: true,
      };
    case Domains.FLIGHT_ABROAD:
    case Domains.FLIGHT_DOMESTIC:
      return {
        ...initialData,
        isDomainFlight: true,
      };
    case Domains.CAR:
      return {
        ...initialData,
        isDomainCar: true,
      };

    default:
      return initialData;
  }
};
